import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { WhiteLabelGendersStatistics } from './wl-genders-statisitcs';

export class WhiteLabelPdfGendersStatistics extends Model {
  @Expose()
  @Type(() => WhiteLabelGendersStatistics)
  beneficiaries: WhiteLabelGendersStatistics;
  @Expose()
  @Type(() => WhiteLabelGendersStatistics)
  letters: WhiteLabelGendersStatistics;
  @Expose()
  @Type(() => WhiteLabelGendersStatistics)
  minutes: WhiteLabelGendersStatistics;
  @Expose()
  @Type(() => WhiteLabelGendersStatistics)
  pages: WhiteLabelGendersStatistics;
  @Expose()
  @Type(() => WhiteLabelGendersStatistics)
  sessions: WhiteLabelGendersStatistics;
}
